import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check`;

export const payActionFee = async (token, d) => {
  try {
    const r = await axios.post(`${API}/fee/checkout`, { amount: d.amount, network: d.network, action: d.action, check_id: d.check_id },
      { headers: { Authorization: `Bearer ${token}` } });
    window.location.href = r.data.checkout_url;
  } catch (e) {
    const m = e.response?.data?.detail;
    toast.error(typeof m === 'string' ? m : 'Could not start fee payment');
  }
};

export const errorText = (err, fallback) => {
  const d = err.response?.data?.detail;
  if (typeof d === 'string') return d;
  return d?.message || fallback;
};

export const actionSuccess = (data) => toast.success(data.message, data.fee_waived ? { description: 'Fee waived · no card payment needed' } : undefined);

export const handleActionError = (err, token, fallback = 'Action failed') => {
  const d = err.response?.data?.detail;
  if (err.response?.status === 402 && d?.action) {
    toast.error(d.message, { duration: 15000, action: { label: `Pay $${Number(d.fee_usd).toFixed(2)}`, onClick: () => payActionFee(token, d) } });
    return;
  }
  toast.error(errorText(err, fallback));
};
